import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, skipWhile, take } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  return authService.getLoggedInUser().pipe(
    skipWhile(value => value === undefined), // Wait until auth state is resolved (no longer undefined)
    take(1), // Take the first non-null value
    map((user) => {
      if (user) {
        return true;
      }
      return router.parseUrl('/login');
    })
  );
};
